import { combineReducers } from "redux";
import { EnterRoamRequestReducer } from "./slices/enterRoamRequestSlice.js";
import { ltcReducer } from "./slices/ltcSlice.js";

export const lobbyReducer = combineReducers({
  ltc: ltcReducer,
  enterRoamRequest: EnterRoamRequestReducer,
});
